import {
  Droppable,
  DroppableProps,
  DroppableProvided,
  DroppableStateSnapshot,
} from "@hello-pangea/dnd";
import { ReactNode } from "react";

interface HighlightDroppableProps extends Omit<DroppableProps, "children"> {
  children: (provided: DroppableProvided, snapshot: DroppableStateSnapshot) => ReactNode;
  className?: string;
}

export const HighlightDroppable = ({
  children,
  className = "",
  ...props
}: HighlightDroppableProps) => {
  return (
    <Droppable {...props}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className={`${
            snapshot.isDraggingOver
              ? "border border-dashed border-dark/10 rounded-md"
              : "border border-transparent"
          } transition-colors duration-200 ${className}`}
        >
          {children(provided, snapshot)}
        </div>
      )}
    </Droppable>
  );
};
